// Experiment configuration, add experiments here
// Note: Allocation percentages must sum to 100
export const EXPERIMENTS = {
  pricing_order: {
    variants: ['original_order', 'reversed_order'],
    allocation: { original_order: 50, reversed_order: 50 },
  },
  onboarding_add_more_images: {
    variants: ['control', 'add_more_images'],
    allocation: { control: 50, add_more_images: 50 },
  },
  mobile_calendar_access: {
    variants: ['allow', 'deny'],
    allocation: { allow: 50, deny: 50 },
  },
  onboarding_strategies: {
    variants: ['off', 'on'],
    allocation: { off: 50, on: 50 },
  },
  onboarding_strategies_mobile: {
    variants: ['off', 'on'],
    allocation: { off: 50, on: 50 },
  },
  credits_dropdown: {
    variants: ['off', 'on'],
    allocation: { off: 50, on: 50 },
  },
  onboarding_v4: {
    variants: ['off', 'on'],
    allocation: { off: 100, on: 0 },
  },
  // example
  // feature_flag_name: {
  //   variants: ['control', 'variant_a', 'variant_b', 'variant_c'],
  //   allocation: { control: 25, variant_a: 25, variant_b: 25, variant_c: 25 },
  // },
} as const

export type ExperimentId = keyof typeof EXPERIMENTS
